export const FeedbacksReasons: any = {
    registration_password_reset: "Проблема с восстановлением пароля",
    payment: "Оплата",
    meters: "Счётчики",
    other: "Другое",
};
